/* globals userURL, loginURL */
import axios from "axios";
import MessagesClient from "dea-notify-client/src/clients/messages";
import notAllowedRoles from "dea-notify-client/src/helpers/notAllowedRoles"; // eslint-disable-line import/no-unresolved
import utils from "../../utils";

export default {
  data() {
    return {
      require_login: false,
      unauthLoadData: false,
      user: {
        first_name: "",
        authenticated: false,
        targetCss: {
          target: "",
          colorMod: "generic-dark-grey",
          bgMod: "bg-grey-dark",
          bgClass: "dea-bg-grey-dark",
          borderMod: "dea-border--grey-dark",
          genericMod: "",
        },
        role_value: "family",
        targetTitle: "",
        targetHome: "/",
        children_map: {},
        bsmart_email: null,
        children: [],
        notifications: [],
      },
      token: null,
      authenticated: false,
      trigger: null,
      loginName: "",
      loginImage: "",
      book_title: "",
      local_user: "",
      local_book: "",
      local_child: "",
      modalOpen: false,
      redirectId: null,
    };
  },
  computed: {
    loginURL() {
      if (this.$root.asyncConf) return this.$root.asyncConf.loginApi;
      if (loginURL) return loginURL;
      return `${this.$root.config.apiRoot}/api/v1/accounts/login/`;
    },
    userURL() {
      if (this.$root.config.userURL) return this.$root.config.userURL;
      return userURL;
    },
  },
  created() {
    this.domain = document.location.origin;
    this.loadUser(null, null, null, this.$root.config.isMinisite);
  },
  methods: {
    openChildBook(child, book) {
      this.modalOpen = true;
      this.local_user = this.user.children_map[child];
      this.local_book = book;
      this.local_child = child;
      this.book_title = book.title;
    },
    confirmOpenChildBook() {
      let link = null;
      if (this.local_book.original_link.indexOf("http") === -1) {
        link = `${document.location.protocol}//${document.location.host}${this.local_book.original_link}`;
      } else {
        link = this.local_book.original_link;
      }
      // console.log('openbook', this.local_child, this.local_book, this.user.children_map);
      axios
        .patch(
          `${this.userSwitchURL}`,
          { child: this.local_child },
          { withCredentials: true, headers: this.buildHeaders(true) }
        )
        .then(response => {
          this.registerLogin(response.data, this.user);
          const registerSwitch = this.$root.config.parent_login
            // eslint-disable-next-line no-template-curly-in-string
            .replace("${child}", this.local_child)
            // eslint-disable-next-line no-template-curly-in-string
            .replace("${url}", link);
          document.location = registerSwitch;
        })
        .catch(() => {
          // console.log("error loading user", error);
        });
    },
    buildHeaders(csrf) {
      const tokenTag = document.getElementsByName("csrfmiddlewaretoken");
      const headers = {};
      const token = this.token ? this.token : this.$cookies.get("deatoken");
      headers.Authorization = `Bearer ${token}`;
      if (tokenTag.length && csrf) {
        headers["X-CSRFToken"] = tokenTag[0].getAttribute("value");
      }
      return headers;
    },
    openLogin(event, redirectId) {
      // eslint-disable-next-line no-param-reassign, prefer-destructuring
      if (!redirectId && this.redirectId) redirectId = this.redirectId;
      let target = null;
      if (!this.token || !this.loginName) {
        target = document.location.href;
      }
      utils.redirectToLogin(event, this.$root.config, target, redirectId);
    },
    openRegister() {
      document.location = `${this.$root.config.register_url}?url=${document.location.href}`;
    },
    openProfile() {
      if (this.user.role_value === "teacher") {
        document.location = `${this.$root.config.profile_teacher_url}?url=${document.location.href}`;
      } else if (this.user.role_value === "parent") {
        document.location = `${this.$root.config.profile_parent_url}?url=${document.location.href}`;
      } else if (this.user.role_value === "student") {
        document.location = `${this.$root.config.profile_student_url}?url=${document.location.href}`;
      }
    },
    openActivate() {
      let url;
      if (this.book) {
        url = `${this.$root.config.activation_book_url}?url=${document.location.href}`.replace("%(book)s", this.book);
      } else {
        url = `${this.$root.config.activation_search_url}?url=${document.location.href}`;
      }
      document.location = url;
    },
    loadUser(callback, book, flowStep, minisite) {
      const headers = this.buildHeaders();
      // when using a callback we really want to have fresh user data
      const userURL = callback || minisite ? `${this.userURL}update/` : this.userURL;
      // console.log('headers', headers, this.userURL);
      if (this.$cookies.get("deatoken")) {
        this.user.loading = true;
        axios
          // eslint-disable-next-line object-shorthand
          .get(userURL, { withCredentials: true, headers: headers })
          .then(response => {
            // console.log("response user", response, response.data);
            if (Object.keys(response.data).length) {
              this.registerLogin(response.data);
              this.trigger = true;
            } else {
              this.trigger = true;
            }
            if (callback) {
              callback(book, flowStep);
            }
            // console.log('returned user', this.user);
          })
          .catch(() => {
            // console.log("error loading user", error);
            this.user.loading = false;
            if (this.require_login) {
              this.forceAuth();
            }
            if (this.getData) {
              this.getData();
            }
            // user is not logged in
          });
      } else if (this.require_login) {
        this.forceAuth();
      } else if (this.unauthLoadData) {
        this.getData();
      }
    },
    forceAuth() {
      this.user.loading = false;
      this.authenticated = false;
      this.user.authenticated = false;
      this.openLogin(null);
    },
    registerLogin(data, parent) {
      this.user.loading = false;
      const secure = document.location.protocol === "https:" && this.$root.config.useSecureCookie;
      if (data.token) {
        this.token = data.token;
        this.$cookies.set("deatoken", data.token, "0", "/", ".deascuola.it", secure, "Lax");
      } else {
        this.token = this.$cookies.get("deatoken");
        // eslint-disable-next-line no-param-reassign
        data.token = this.token;
      }
      if (parent) {
        this.parent_token = parent.token;
        this.$cookies.set("deatoken_parent", parent.token, "0", "/", ".deascuola.it", secure, "Lax");
      }
      this.setUser(data);
      // this setting must be added to each project separately
      if (this.$root.config.messages && this.$root.config.messages.enable) {
        this.getAllMessages(this.token).then(res => {
          this.$set(this.user, "notifications", res);
        });
      }
    },
    /**
     * Set the user object on the current component and propagate it via custom
     * event to ensure data is kept in sync
     *
     * @param data: user object
     */
    setUser(data) {
      this.authenticated = true;
      this.userCssClasses = this.user.targetCss;
      this.$root.config.userCssClasses = this.user.targetCss;
      this.user = data;
      this.user.authenticated = true;
      this.$root.user = this.user;
      const event = new CustomEvent("userLoaded", { detail: this.user });
      document.querySelector("body").dispatchEvent(event);
      this.afterUserLoaded();
    },
    afterUserLoaded() {},
    getAllMessages(token) {
      if (!this.user.role.includes(notAllowedRoles)) {
        return MessagesClient.getAll(token)
          .then(res => {
            return res;
          })
          .catch(err => {
            console.log(err);
          });
      }
      return [];
    },
  },
};
